<template>
  <v-container class="news-list">
    <v-row>
      <v-col cols="12">
        <h2>Noticias</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(news, index) in newsList" :key="index" cols="12" sm="6" md="3">
        <v-card>
          <v-img :src="news.image" alt="Imagen de noticia" height="200px"></v-img>
          <v-card-title>{{ news.title }}</v-card-title>
          <v-card-subtitle>{{ news.subtitle }}</v-card-subtitle>
          <v-card-text v-if="news.tags.length">
            <v-chip v-for="(tag, tagIndex) in news.tags" :key="tagIndex" color="blue" text-color="white">
              {{ tag }}
            </v-chip>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" :to="`/noticia/${news._id}`">Leer</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import ApiService from '../../services/api.service';

export default {
  data () {
    return {
      newsList: []
    };
  },
  async created () {
    try {
      const url = ApiService.getEndpoint('/news');
      const response = await fetch(url);
      const data = await response.json();
      this.newsList = data;
    } catch (error) {
      console.error('Error al cargar las noticias:', error);
    }
  }
};
</script>
